import script from "./BaseShapeElement.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseShapeElement.vue?vue&type=script&lang=ts&setup=true"

import "./BaseShapeElement.vue?vue&type=style&index=0&id=0a56795e&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a56795e"]])

export default __exports__